export default __webpack_public_path__ + "static/media/YUAN300_360_mobile.5a1a1206.jpg";